export default () => ({
  status: undefined,
  data: {},
  date: undefined,
  location: {},
  firstConfigLocation: {},
});
